<template>
    <div class="supplierlist">
        <el-row :gutter="24" v-if="innerWidth>767">
            <el-col style="padding: 0 0.5em;" :span="innerWidth>1024?6:innerWidth<768?12:8" v-for="(item, index) in supplierList" :key="item.name" :offset="index > 0 ? 2 : 0">
                <div @click="detail(item.id)">
                    <el-card class="card">
                        <div class="imgbox">
                            <img :src="item.logo.file_path" class="image">
                        </div>
                        <div>
                            <h3 style="margin-top: 0.2em;" class="name">{{ item.name }}</h3>
                            <div class="intro" style="color: #666;margin-top: 0.2em;">全球领先的打印解决方案提供商</div>
                            <div class="tagbox" >
                                <div v-for="(tag,index) in item.tagassoc " :key="index" v-if="index<2" class="tag" style="color:#353535;">{{tag.title}}</div>
                            </div>
                        </div>
                    </el-card>
                </div>

            </el-col>
        </el-row>
        <el-row :gutter="24" v-if="innerWidth<=767">

            <el-col style="padding: 0 0.5em;" :span="24" v-for="(item, index) in supplierList" :key="item.name" :offset="index > 0 ? 2 : 0">
                <div @click="detail(item.id)">
                    <el-card>
                        <div  class="card">
                            <div class="imgbox">
                            <img :src="item.logo.file_path" class="image">
                        </div>
                        <div class="info">
                            <h3 style="margin-top: 0.2em;" class="name">{{ item.name }}</h3>
                            <div class="intro" style="color: #666;margin-top: 0.2em;">全球领先的打印解决方案提供商</div>
                            <div class="tagbox" >
                                <div v-for="(tag,index) in item.tagassoc " :key="index" v-if="index<3" class="tag" style="color:#353535;">{{tag.title}}</div>
                            </div>
                        </div>
                        </div>
                        
                    </el-card>
                </div>

            </el-col>
        </el-row>
        <h2 style="margin-left: 20px;color: #333;">厂家优选</h2>
        <el-row :gutter="20">
            <el-col :span="innerWidth>1024?6:innerWidth<768?12:8" v-for="(item1, index) in recommendlist" :key="item1.name" :offset="index > 0 ? 2 : 0">
                <div @click="detail(item1.id)">
                    <el-card>
                        <div class="imgbox">
                            <img :src="item1.logo.file_path" class="images" >
                        </div>
                        <div>
                            <div class="name" style="color: #666;margin-top: 20px;text-align: center;">{{item1.name}}</div>
                        </div>
                    </el-card>

                </div>

            </el-col>
        </el-row>
        <!-- 二维码弹窗 -->
        <div>
            <el-dialog :visible.sync="dialogVisible" width="70%" custom-class="custom-dialog">
                <div class="dialogs">
                        <div  class="cards">
                            <div class="imgbox">
                                <img :src="detailInfo.pic" class="image">
                            </div>
                        <div class="info">
                            <h3 style="margin-top: 0.2em;" class="name">{{ detailInfo.name }}</h3>
                            <div class="intro" style="color: #666;margin-top: 0.2em;">{{detailInfo.overview}}</div>
                        </div>
                        </div>
                        <div class="qrcbox" v-if="innerWidth>767">
                            <img class="qrcimg" :src="current_qrcode" alt="">
                            <div class="txt">了解企业详细介绍请扫码进入小程序</div>
                        </div>
                </div>
                <div class="tagboxs" >
                    <div v-for="(tag,index) in detailInfo.tagassoc " :key="index" class="tags" :style="'color:'+tag.text_color,'background:'+tag.bg_color">{{tag.title}}</div>
                </div>
                <div style="margin-top: 10px;">
                    <div>公司介绍：</div>
                    <p v-html="content"></p>
                </div>
                <div class="qrcbox" v-if="innerWidth<=767">
                    <img class="qrcimg" :src="current_qrcode" alt="">
                    <div>了解企业详细介绍请扫码进入小程序</div>
                </div>

            </el-dialog>
        </div>
    </div>
</template>

<script>
import {supplierDetail} from '../api/api'
import { mapState, mapMutations } from 'vuex'
import DOMPurify from 'dompurify';
export default {
    props: {
        supplierList: { 
            type: Array, 
            default: function () {
                return [];
            }},
        recommendlist: { 
            type: Array, 
            default: function () {
                return [];
            } },
            innerWidth: {
            type: Number,
            default: 0
        },
        
    },
    name: 'supplierList',
    data() {
        return {
            dialogVisible: false,
            detailInfo:'',
            content:'',
            current_qrcode:''
        }
    },
    computed: {
        ...mapState({
            tags: state => state.tab.tabsList
        })
    },
    methods: {
        ...mapMutations(['closeTag']),
        detail(id) {
            console.log('wwwwwwwwwwwww');
           
            const data = {
                id:id,
                token: "",
                wxapp_id: '10001'
            }
            supplierDetail(data).then(response => {
               
                this.detailInfo = response.data.data.detail;
                this.content = this.showHtml(this.detailInfo.intro);
                 this.current_qrcode= this.detailInfo.qrcodes.data.qrcode
                console.log(this.detailInfo);
            }).catch(error => {
                    console.error(error);
            });
            // this.$router.push({path:'/Detail?id='+id})
            this.dialogVisible = !this.dialogVisible
        },

        showHtml(str){
        return str
            .replace(str ? /&(?!#?\w+;)/g : /&/g, '&amp;')
            .replace(/&lt;/g,"<")
            .replace(/&gt;/g,">")
            .replace(/&quot;/g,"\"")
            .replace(/&#39;/g, "\'")
            .replace(/&amp;nbsp;/g,'\u3000')
        },

        
    }
}
</script>
<style lang="less" scoped>
/deep/ .el-dialog__body {
  img {
    max-width: 100%;
    height: auto;
  }
  
  p {
    margin: 10px 0;
    line-height: 1.6;
  }
  
  ul, ol {
    padding-left: 20px;
  }
}
.el-row {
    padding: 0;

}

.el-col {
    margin: 0;

    // width: 20em;
    margin-bottom: 20px;
}

.el-card {
    border-radius: 10px;
}

.name {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    
}

.dialog {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    overflow: hidden;
   
    
          
    .qrcode {
        width: 14em;
        height: 14em;
    }
    .txt{
        font-size: 1em;
    }
}
.imgbox{
    display: flex;
    justify-content: center;
    align-items: center;
}
.image{
    border: 1px solid #eee;
}
.qrcbox{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}


@media (max-width: 767px) {
    .supplierlist{
        margin:0.5em 1em 1em 1em;
    }
    .image {
        width: 4em;
        height: 4em;
        // display: block;
        border-radius: 50%;
       
    }
    .images{
        width: 8em;
        height: 8em;
        border-radius: 50%;
        border: 1px solid #eee;
    }
    .tagbox{
        display: flex;
        // margin-top: 0.5em;
        // border: 1px solid black;
        // flex-wrap: wrap;
    }
    .tag {
        background-color: #eee;
        color: #999;
        padding: 5px 8px;
        font-size: 0.2em;
        margin-right: 5px;
        white-space: nowrap;
        border-radius: 5px;
        margin-top: 5px;
    }
    .name{
        font-size: 1em
    }
    .intro{
        font-size: 0.8em;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .card{
        display: flex;
        flex-direction: row;
    }

    .info{
        margin-left: 1em;
    }

    .cards{
        display: flex;
        .intro{
            white-space: wrap;
        }

    }
    .tagboxs{
            display: flex;
            flex-wrap: wrap;
         .tags{
            // font-size: 2em;
            display: flex;
            margin:10px 10px 0 0;
            padding: 5px 10px;
            border-radius: 5px;
         } 
        }
        .qrcbox{
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            margin-top: 20px;
            .qrcimg{
               width: 15em;
               height: 15em;
               margin-bottom: 10px;
           }
        }
        .dialogs{
            .image{
                height: 5em;
                width: 5em;
            }

            .info{
                width: 80%;
            }
        }
}

/* 平板样式 */
@media (min-width: 768px) and (max-width: 1023px) {
    .supplierlist{
        margin: 1em;
    }
    .image,.images {
        width: 10em;
        height: 10em;
        // display: block;
        border-radius: 50%;
    }
    .tagbox{
        display: flex;
        // flex-wrap: wrap;
        
    }
    .tag {
        background-color: #eee;
        color: #999;
        padding: 0.8em 2em;
        font-size: 0.4em;
        margin-right: 1em;
        white-space: nowrap;
        border-radius: 5px;
        margin-top: 5px;
    }
    .name{
        font-size: 1.1em
    }
    .intro{
        font-size: 0.9em
    }
    .card{
        height: 19em;
    }
    .imgbox{
    display: flex;
    justify-content: center;
    align-items: center;
}
.dialogs{
    display: flex;
    align-items: center;
    .cards{
        // display: flex;
        // align-items: center;
        flex: 1;
        // wdith: 75%;
        .image{
            height: 10em;
            width: 10em;
        }
    }
    .qrcbox{
        margin-left: 10px;
        width: 25%;
        text-align: center;
        .qrcimg{
           width: 10em;
           height: 10em;
       }

    }
}
}

/* 桌面样式 */
@media (min-width: 1024px) {
    .image,.images {
        width: 12em;
        height: 12em;
        // display: block;
        border-radius: 50%;
    }
    .tagbox{
        display: flex;
        // flex-wrap: wrap;
      
    }
    .tag {
        background-color: #eee;     
        color: #999;
        padding: 0.6em 0.8em;
        font-size: 0.6em;
        margin-right: 1em;
        white-space: nowrap;
        border-radius: 5px;
        margin-top: 5px
    }
    .name{
        font-size: 1.1em
        
    }
    .intro{
        font-size: 0.9em
    }
    .card{
        height: 21em;
    }
    .dialogs{
    display: flex;
    align-items: center;
    .cards{
        // display: flex;
        // align-items: center;
        flex: 1;
        // wdith: 75%;
        .image{
            height: 10em;
            width: 10em;
        }
    }
    .qrcbox{
        margin-left: 10px;
        width: 25%;
        text-align: center;
        .qrcimg{
           width: 12em;
           height: 12em;
       }

    }
}
    
}
.cards{
        display: flex;
        .intro{
            white-space: wrap;
        }
        // .images{
        //     width: 8em;
        //     height: 8em;
        // }
        .info{
            margin-left: 20px;
        }

    }
    .tagboxs{
            display: flex;
            flex-wrap: wrap;
         .tags{
            // font-size: 2em;
            display: flex;
            margin:10px 10px 0 0;
            padding: 5px 10px;
            border-radius: 5px;
         } 
        }

</style>